import React, { useEffect, useState } from "react"
import { Box, Typography, Button } from "@mui/material"
import { Container, Row, Col } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { blogsAPI } from "../../services/blogsAPI"
import RichTextRenderer from "../RichTextRenderer"
import { getStrapiMedia } from "../../utils/strapiMedia"

const BlogsSection = () => {
  const [blogs, setBlogs] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const data = await blogsAPI.getAllBlogs()
        setBlogs(data)
      } catch (err) {
        console.error("Error fetching blogs:", err)
      }
    }

    fetchBlogs()
  }, [])

  useEffect(() => {
    document.title = "Latest Blogs | First Legal India" // Change title here
  }, [])
  return (
    <Box sx={{ py: 6, bgcolor: "#f2f2f282", width: "100%" }}>
      <Container>
        <Typography variant='h4' mt={4} mb={1} align='center'>
          Our Blogs
        </Typography>
        <Typography variant='h6' mb={4} align='center'>
          Latest Blogs and Articles
        </Typography>

        <Row className='g-4'>
          {blogs?.slice(0, 3).map((blog) => (
            <Col xs={12} md={4} key={blog.id}>
              <Box
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 3,
                  overflow: "hidden",
                  border: "1px solid #e0e0e0",
                  height: "100%",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  },
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {blog?.image && (
                  <Box
                    component='img'
                    src={getStrapiMedia(blog.image)}
                    alt={blog.image.alternativeText || blog.title}
                    sx={{
                      width: "100%",
                      height: { xs: 220, md: 220 },
                      objectFit: "cover",
                      borderRadius: 3,
                      mb: 1.2,
                    }}
                  />
                )}

                <Box
                  sx={{
                    p: 3,
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography variant='caption' color='text.secondary'>
                    {blog.date
                      ? new Date(blog.date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })
                      : ""}
                  </Typography>
                  <Typography variant='h6' mt={1}>
                    {blog?.title}
                  </Typography>

                  <Box sx={{ mt: 1, mb: 2, flex: 1 }}>
                    <RichTextRenderer content={blog.summary} />
                  </Box>

                  <Button
                    variant='outlined'
                    size='small'
                    onClick={() => navigate(`/blogs/${blog.slug}`)}
                    sx={{ mt: 2 }}
                  >
                    Read More
                  </Button>
                </Box>
              </Box>
            </Col>
          ))}
        </Row>
      </Container>
    </Box>
  )
}

export default BlogsSection
